import makeList from './makeList.js'

let params = [
  {
    name: 'shirase',
    locations: [
      { description: '観測隊公室',
        file: './data/360_01_17CUNx.jpg',
        rotation: 165,
        link: [
          {
            file: './data/360_06_17DJjV.jpg',
            position: [ 4756.274457975351, -58.45136792779461, -1532.5225057035161 ],
          },
          {
            file: './data/360_17_17DJqV.jpg',
            position: [ 4986.517793555021, -45.606114999180406, 223.06356279169478 ],
          },
        ],
        info: [
        ],
        view: {
          shirase: [ 737.1937639198218, 374.16481069042317 ],
        },
      },
      { description: '隊員事務室',
        file: './data/360_02_16yFDy.jpg',
        rotation: 168.128369284594,
        link: [
          {
            file: './data/360_17_17DJqV.jpg',
            position: [ 124.93199269045502, -810.4456334265618, -4926.270458008466 ],
          },
        ],
        info: [
        ],
        view: {
          shirase: [ 549.520766773163, 421.7252396166134 ],
        },
      },
      { description: '第2観測室',
        file: './data/360_03_16yFDn_2.jpg',
        rotation: 98.27824590971733,
        link: [
          {
            file: './data/360_10_17DJjS.jpg',
            position: [ -17.496213364742566, -404.7972662814049, -4982.1898045751295 ],
          },
        ],
        info: [
        ],
        view: {
          shirase: [ 252.3961661341853, 369.00958466453676 ],
        },
      },
      { description: '第3観測室',
        file: './data/360_04_16yFDx_3.jpg',
        rotation: 113.92237656256165,
        link: [
          {
            file: './data/360_12_17DJjY.jpg',
            position: [ 1589.4200117230205, -654.9807740616848, -4688.519561145416 ],
          },
        ],
        info: [
        ],
        view: {
          shirase: [ 182.6923076923077, 362.1794871794871 ],
        },
      },
      { description: '第4観測室',
        file: './data/360_05_16yFDo_4.jpg',
        rotation: 82.28741110133419,
        link: [
          {
            file: './data/360_13_17DJjX.jpg',
            position: [ -232.80833394266452, -161.41556416487452, 4981.456852419322 ],
          },
        ],
        info: [
        ],
        view: {
          shirase: [ 157.9532814238042, 311.4571746384872 ],
        },
      },
      { description: '左舷廊下１',
        file: './data/360_06_17DJjV.jpg',
        rotation: -134.1340559619481,
        link: [
          {
            file: './data/360_01_17CUNx.jpg',
            position: [ -4945.340116937705, -564.2584306870725, -360.5099063142224 ],
          },
          {
            file: './data/360_22_17DJqh.jpg',
            position: [ 248.0989853024376, -199.57113636061388, -4979.156340218833 ],
          },
          {
            file: './data/360_21_17DJqf.jpg',
            position: [ 4547.168171932825, -152.41186000387557, 2060.8602426826737 ],
          },
          {
            file: './data/360_07_17DJjR.jpg',
            position: [ 4984.364509726176, -112.87553835079319, 213.71802450927606 ],
          },
        ],
        info: [
        ],
        view: {
          shirase: [ 568.4093437152392, 354.83870967741933 ],
        },
      },
      { description: '左舷廊下２',
        file: './data/360_07_17DJjR.jpg',
        rotation: 61.710212045121544,
        link: [
          {
            file: './data/360_08_17DJjZ.jpg',
            position: [ 4960.9281905162525, -194.49755734583783, -547.6121996637388 ],
          },
          {
            file: './data/360_06_17DJjV.jpg',
            position: [ -4974.270432418957, -8.865333098166463, 484.30139336483603 ],
          },
          {
            file: './data/360_20_17DJqg.jpg',
            position: [ -856.221242380468, -301.7965100030262, -4907.786881916585 ],
          },
        ],
        info: [
        ],
        view: {
          shirase: [ 500.00000000000006, 348.24281150159743 ],
        },
      },
      { description: '左舷廊下３',
        file: './data/360_08_17DJjZ.jpg',
        rotation: -8.831427378234917,
        link: [
          {
            file: './data/360_07_17DJjR.jpg',
            position: [ -4974.5739857747485, -216.31948822572318, 322.9843194064377 ],
          },
          {
            file: './data/360_09_17DJjU.jpg',
            position: [ 4953.530707566517, -578.9657928412952, -171.00324777723287 ],
          },
        ],
        info: [
        ],
        view: {
          shirase: [ 426.5175718849841, 338.6581469648562 ],
        },
      },
      { description: '左舷廊下４',
        file: './data/360_09_17DJjU.jpg',
        rotation: -110.84868517597847,
        link: [
          {
            file: './data/360_08_17DJjZ.jpg',
            position: [ -4910.253742529932, -401.15254179650987, -811.2558402527247 ],
          },
          {
            file: './data/360_10_17DJjS.jpg',
            position: [ -654.9552773229971, -267.7731382799729, 4941.015845803545 ],
          },
        ],
        info: [
        ],
        view: {
          shirase: [ 347.05228031145714, 321.46829810901 ],
        },
      },
      { description: '観測室廊下１',
        file: './data/360_10_17DJjS.jpg',
        rotation: 231.11842294928915,
        link: [
          {
            file: './data/360_09_17DJjU.jpg',
            position: [ 1617.3466145035948, -202.16832681294966, -4719.047224112068 ],
          },
          {
            file: './data/360_11_17DJjQ.jpg',
            position: [ 4815.678747223972, -266.30756321239323, 1279.3122900309384 ],
          },
          {
            file: './data/360_14_17DJoA.jpg',
            position: [ -1186.4860762462401, -389.3629332910984, 4835.552874776555 ],
          },
        ],
        info: [
        ],
        view: {
          shirase: [ 335.4632587859425, 349.8402555910543 ],
        },
      },
      { description: '観測室廊下２',
        file: './data/360_11_17DJjQ.jpg',
        rotation: -67.10903406430108,
        link: [
          {
            file: './data/360_10_17DJjS.jpg',
            position: [ -4973.819575176611, -316.11712419279417, 262.5596204470301 ],
          },
          {
            file: './data/360_12_17DJjY.jpg',
            position: [ 4986.602441865486, -57.80629306094399, -212.3032734336157 ],
          },
          {
            file: './data/360_03_16yFDn_2.jpg',
            position: [ 192.46921554909304, -396.9704926525991, 4973.946368018285 ],
          },
        ],
        info: [
        ],
        view: {
          shirase: [ 263.5782747603834, 343.4504792332268 ],
        },
      },
      { description: '観測室廊下３',
        file: './data/360_12_17DJjY.jpg',
        rotation: 90.95245848688376,
        link: [
          {
            file: './data/360_11_17DJjQ.jpg',
            position: [ -4987.781512389125, -143.2964869700564, 125.71352470430313 ],
          },
          {
            file: './data/360_13_17DJjX.jpg',
            position: [ 4961.602732255394, -486.35384400687144, 226.13893993356135 ],
          },
          {
            file: './data/360_04_16yFDx_3.jpg',
            position: [ -69.86810693303865, -342.6644057844582, 4982.874824367861 ],
          },
        ],
        info: [
        ],
        view: {
          shirase: [ 193.29073482428117, 338.6581469648562 ],
        },
      },
      { description: '観測室廊下４',
        file: './data/360_13_17DJjX.jpg',
        rotation: 83.15584346728957,
        link: [
          {
            file: './data/360_12_17DJjY.jpg',
            position: [ -4992.046838245979, -26.590265363927582, -131.8198469998185 ],
          },
          {
            file: './data/360_23_17En4D.jpg',
            position: [ 4969.946453795943, -438.4896269042025, -175.02417617130314 ],
          },
          {
            file: './data/360_05_16yFDo_4.jpg',
            position: [ -2493.8109527986667, -513.4927381520039, -4298.712578765781 ],
          },
        ],
        info: [
        ],
        view: {
          shirase: [ 137.38019169329075, 330.6709265175719 ],
        },
      },
      { description: '右舷廊下４',
        file: './data/360_14_17DJoA.jpg',
        rotation: -9.806453250201088,
        link: [
          {
            file: './data/360_15_17DJqR.jpg',
            position: [ -4496.458109229103, -795.3352003339348, -2032.389908531669 ],
          },
          {
            file: './data/360_10_17DJjS.jpg',
            position: [ 2190.5673858221553, -232.8627219109949, -4477.536446715182 ],
          },
        ],
        info: [
        ],
        view: {
          shirase: [ 329.073482428115, 383.38658146964855 ],
        },
      },
      { description: '右舷廊下３',
        file: './data/360_15_17DJqR.jpg',
        rotation: -1.0651188689968418,
        link: [
          {
            file: './data/360_16_17DJqP.jpg',
            position: [ -4986.875503288378, -191.3703803661986, -106.95730264119359 ],
          },
          {
            file: './data/360_14_17DJoA.jpg',
            position: [ 4990.0545076382205, -150.7551042667381, 76.74814633547186 ],
          },
        ],
        info: [
        ],
        view: {
          shirase: [ 390.4338153503893, 390.4338153503893 ],
        },
      },
      { description: '右舷廊下２',
        file: './data/360_16_17DJqP.jpg',
        rotation: 101.8993470213045,
        link: [
          {
            file: './data/360_15_17DJqR.jpg',
            position: [ 4985.014591833948, -274.89401661828134, -79.84859104340026 ],
          },
          {
            file: './data/360_17_17DJqV.jpg',
            position: [ -4992.288792677096, -29.78184790822406, 124.81109957039432 ],
          },
          {
            file: './data/360_18_17DJqd.jpg',
            position: [ 301.87387232658534, -505.74039999539707, 4955.338923744515 ],
          },
        ],
        info: [
        ],
        view: {
          shirase: [ 453.67412140575084, 392.9712460063898 ],
        },
      },
      { description: '右舷廊下１',
        file: './data/360_17_17DJqV.jpg',
        rotation: -114.26420187133867,
        link: [
          {
            file: './data/360_16_17DJqP.jpg',
            position: [ 4988.406475676447, -130.0919186518625, -123.6881031443121 ],
          },
          {
            file: './data/360_01_17CUNx.jpg',
            position: [ -4971.49753405275, -462.66025496603055, -90.84190792703042 ],
          },
          {
            file: './data/360_02_16yFDy.jpg',
            position: [ -4071.792463605313, -90.8580554770497, 2891.254772040652 ],
          },
        ],
        info: [
        ],
        view: {
          shirase: [ 517.5718849840256, 399.36102236421726 ],
        },
      },
      { description: '観測隊長公室',
        file: './data/360_18_17DJqd.jpg',
        rotation: -16.298464168801942,
        link: [
          {
            file: './data/360_16_17DJqP.jpg',
            position: [ -2457.814369750204, -278.2524993225039, -4339.368589146609 ],
          },
          {
            file: './data/360_19_17DJqe.jpg',
            position: [ -4890.93468430096, -580.9146426259985, -797.4094238773998 ],
          },
        ],
        info: [
        ],
        view: {
          shirase: [ 445.6869009584665, 410.54313099041536 ],
        },
      },
      { description: '観測隊長寝室',
        file: './data/360_19_17DJqe.jpg',
        rotation: 125.39626742030367,
        link: [
          {
            file: './data/360_18_17DJqd.jpg',
            position: [ 4091.863533494232, -56.486988502359345, -2862.8241678762784 ],
          },
        ],
        info: [
        ],
        view: {
          shirase: [ 485.6230031948882, 416.9329073482428 ],
        },
      },
      { description: '副隊長寝室',
        file: './data/360_20_17DJqg.jpg',
        rotation: 161.90908036275044,
        link: [
          {
            file: './data/360_07_17DJjR.jpg',
            position: [ 1298.9674166152827, -364.3569696112043, 4806.429264313068 ],
          },
        ],
        info: [
        ],
        view: {
          shirase: [ 512.779552715655, 327.47603833865816 ],
        },
      },
      { description: '観測隊員寝室',
        file: './data/360_21_17DJqf.jpg',
        rotation: 74.84621080256335,
        link: [
          {
            file: './data/360_06_17DJjV.jpg',
            position: [ -135.08969939607496, -381.6159964288592, -4977.926388757515 ],
          },
        ],
        info: [
        ],
        view: {
          shirase: [ 547.9233226837061, 362.6198083067093 ],
        },
      },
      { description: '観測隊員寝室',
        file: './data/360_22_17DJqh.jpg',
        rotation: -108.88448968146857,
        link: [
          {
            file: './data/360_06_17DJjV.jpg',
            position: [ -4733.561472320401, -527.402922268987, 1504.9784501349268 ],
          },
        ],
        info: [
        ],
        view: {
          shirase: [ 573.482428115016, 335.4632587859425 ],
        },
      },
      { description: '観測甲板',
        file: './data/360_23_17En4D.jpg',
        rotation: -177.77956527277547,
        link: [
          {
            file: './data/360_13_17DJjX.jpg',
            position: [ -4976.184270001374, -52.14715156759945, 415.33566726412397 ],
          },
        ],
        info: [
        ],
        view: {
          shirase: [ 87.85942492012781, 322.68370607028754 ],
        },
      },
    ],
  },
]

export default makeList(params)
